
export default {
    name: "the-consent-toggle-item",
    props: {
        title: {
            required: true,
            default: ''
        },
        icon: {
            required: false,
            default: ''
        },
        iconSize: {
            required: false,
            default: '28px',
        },
        toggled: {
            required: true,
            default: false,
        },
        disabled: {
            required: false,
            default: false
        },
        switchColor: {
            required: false,
            default: '#579FA7' //Fixit color default
        },
        subPadding: {
            default: false,
            type: Boolean,
            required: false
        },
        indeterminate: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    computed: {
        toggleState: {
            get() {
                return this.toggled.toggleState
            },
            set(val) {
                this.$emit('setState', {id: this.toggled.id, toggleState: val, parentDescription: this.toggled.parentDescription})
            }
        }
    },
    methods: {
        consentTitle(title) {
            if (title != 'SMS') {
                return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
            } else {
                return title
            }
        }
    }
};
